// Per-template form component registry. Edit page'i overlay.type+variant ile
// bu map'ten lookup yapar.
import type { ComponentType } from 'react'
import ElectionForm from './voting/election/form'
import PollForm from './voting/poll/form'
import CountdownForm from './countdown/simple/form'
import SubscriberForm from './goal/subscriber/form'
import TwitterFeedManualForm from './social/twitter-feed-manual/form'
import TwitterFeedAutoForm from './social/twitter-feed-auto/form'
import FootballScoreForm from './score/football/form'

export interface TemplateFormProps {
  overlayId: string
  initial: Record<string, unknown>
}

const map: Record<string, ComponentType<TemplateFormProps>> = {
  'voting/election': ElectionForm,
  'voting/poll': PollForm,
  'countdown/simple': CountdownForm,
  'goal/subscriber': SubscriberForm,
  'social/twitter-feed-manual': TwitterFeedManualForm,
  'social/twitter-feed-auto': TwitterFeedAutoForm,
  'score/football': FootballScoreForm,
}

export function getForm(type: string, variant: string): ComponentType<TemplateFormProps> | null {
  return map[`${type}/${variant}`] ?? null
}
